import MuiBox from '@new-components/atoms/MuiBox';
import MuiButton from '@new-components/atoms/MuiButton';
import MuiTypography from '@new-components/atoms/MuiTypography';
import {PRIMARY_MESSAGE, SECONDARY_MESSAGE} from './constants';
import {SuccessLogo} from './icon';
import {ImageObj} from '@custom-types/ImageObj.types';
import styles from './styles';
import Image from 'next/image';
import ReactHtmlParser from '@libs/reactHtmlParser';
import {MediaQuery} from '@constants/theme';

type Props = {
  /**
   * function to be called when the Finish button is clicked.
   */
  handleOnClick: () => void;
  /**
   * Custom message to be displayed as the primary message.
   */
  primaryMessage?: string;
  /**
   * Custom message to be displayed as the secondary message.
   */
  secondaryMessage?: string;
  /**
   * QR image data
   */
  image?: ImageObj;
  /**
   * App store liks
   */
  appUrls?: {
    android: string;
    ios: string;
  };
};

const RegisterInterestSuccess = (props: Props) => {
  return (
    <MuiBox sx={styles.container}>
      <MuiBox sx={styles.box}>
        <SuccessLogo />
        <MuiTypography component='div' sx={styles.primary}>
          {props.primaryMessage
            ? ReactHtmlParser(props.primaryMessage)
            : PRIMARY_MESSAGE}
        </MuiTypography>
        <MuiTypography component='div' sx={styles.secondary}>
          {props.secondaryMessage
            ? ReactHtmlParser(props.secondaryMessage)
            : SECONDARY_MESSAGE}
        </MuiTypography>
        {props.image && (
          <MuiBox sx={{marginTop: '20px'}}>
            <Image
              src={props.image?.url}
              alt={props.image?.alt}
              height={150}
              width={150}
            />
          </MuiBox>
        )}
        {props.appUrls && (
          <MuiBox
            sx={{
              display: 'flex',
              gap: '12px',
              marginTop: '8px',
            }}>
            <MuiButton
              sx={{
                background: '#2D2D2D',
                color: '#FFFFFF',
                backdropFilter: 'blur(80px)',
                fontSize: '15px',
                fontWeight: 500,
                lineHeight: '18.75px',
                letterSpacing: '-0.4000000059604645px',
                textAlign: 'center',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                padding: '10px 14px',
              }}
              startIcon={
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M14.2081 16.9C13.3915 17.6917 12.4998 17.5667 11.6415 17.1917C10.7331 16.8083 9.89981 16.7917 8.94148 17.1917C7.74148 17.7083 7.10814 17.5583 6.39148 16.9C2.32481 12.7083 2.92481 6.325 7.54148 6.09167C8.66648 6.15 9.44981 6.70833 10.1081 6.75833C11.0915 6.55833 12.0331 5.98333 13.0831 6.05833C14.3415 6.15833 15.2915 6.65833 15.9165 7.55833C13.3165 9.11667 13.9331 12.5417 16.3165 13.5C15.8415 14.75 15.2248 15.9917 14.1998 16.9083L14.2081 16.9ZM10.0248 6.04167C9.89981 4.18333 11.4081 2.65 13.1415 2.5C13.3831 4.65 11.1915 6.25 10.0248 6.04167Z'
                    fill='white'
                  />
                </svg>
              }
              href={props.appUrls.ios}>
              App Store
            </MuiButton>
            <MuiButton
              sx={{
                background: '#2D2D2D',
                color: '#FFFFFF',
                backdropFilter: 'blur(80px)',
                fontSize: '15px',
                fontWeight: 500,
                lineHeight: '18.75px',
                letterSpacing: '-0.4000000059604645px',
                textAlign: 'center',
                textUnderlinePosition: 'from-font',
                textDecorationSkipInk: 'none',
                padding: '10px 14px',
              }}
              startIcon={
                <svg
                  width='20'
                  height='20'
                  viewBox='0 0 20 20'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M3.03094 2.86169L10.3143 10.0042L3.08511 17.2125C2.96714 17.0583 2.87535 16.8857 2.81344 16.7017C2.78094 16.4932 2.78094 16.281 2.81344 16.0725V3.80586C2.79178 3.47669 2.86761 3.14752 3.03011 2.86169M13.4518 6.88919L11.0743 9.24419L3.87761 2.16669C4.11094 2.08586 4.36094 2.06336 4.60511 2.10169C4.98844 2.20669 5.35428 2.36836 5.69011 2.57919L12.2034 6.18336C12.6268 6.41086 13.0393 6.65003 13.4518 6.88919ZM11.0751 10.775L13.4409 13.0984L11.7259 14.0534L6.49344 16.9617C6.06011 17.2009 5.62511 17.4292 5.20178 17.69C5.02068 17.8029 4.81755 17.8758 4.606 17.9038C4.39445 17.9318 4.17936 17.9144 3.97511 17.8525L11.0751 10.775ZM17.2084 10.0042C17.215 10.2957 17.1415 10.5834 16.9961 10.8361C16.8507 11.0888 16.6388 11.2968 16.3834 11.4375L14.4284 12.5225L11.8559 10.0042L14.4393 7.44252C15.1018 7.81169 15.7534 8.18086 16.4043 8.52836C16.664 8.67328 16.8773 8.88884 17.0195 9.15005C17.1616 9.41126 17.2277 9.70742 17.2084 10.0042Z'
                    fill='white'
                  />
                </svg>
              }
              href={props.appUrls.android}>
              Play Store
            </MuiButton>
          </MuiBox>
        )}
      </MuiBox>
      <MuiButton fullWidth sx={styles.btn} onClick={props.handleOnClick}>
        Finish
      </MuiButton>
    </MuiBox>
  );
};

export default RegisterInterestSuccess;
